export default __webpack_public_path__ + "eec128be22a15563ff8ec0f0c3fbf517.woff?proxy=wpt-abc";